const DRAWER_MODES = {
  BASIC: 'basic',
  ADVANCED: 'advanced',
};

export default DRAWER_MODES;
